// extracted by mini-css-extract-plugin
export default {"StrollerDetailRating":"yb_a bih_a bih_x","StrollerDetailRating__muted":"yb_b bih_fo"};